module.exports = __webpack_public_path__ + "static/media/slider08.1646a71e.jpg";